import { firstGraphQLError, stayErrorMessage } from '../StayHostPage/stayErrors';

export interface WorkerPublishProblem {
  code: string;
  field?: string | null;
  message: string;
}

/** `PROVIDER_NOT_PUBLISHABLE` carries the problems in `extensions.details.problems`. */
export function workerPublishProblemsOf(error: unknown): WorkerPublishProblem[] {
  const gqlError = firstGraphQLError(error);
  if (gqlError?.extensions?.code !== 'PROVIDER_NOT_PUBLISHABLE') return [];
  const problems = gqlError.extensions?.details?.problems;
  return Array.isArray(problems) ? problems : [];
}

/** Field problems of a refused save (`details.errors` or `details.problems` with a field). */
export function fieldProblemsOf(error: unknown): { field: string; message: string }[] {
  const details = firstGraphQLError(error)?.extensions?.details;
  const list = Array.isArray(details?.errors)
    ? details.errors
    : Array.isArray(details?.problems)
      ? details.problems
      : [];
  return list
    .filter((p: any) => typeof p?.field === 'string' && typeof p?.message === 'string')
    .map((p: any) => ({ field: p.field, message: p.message }));
}

/** The error code the API sent, if any. */
export function errorCodeOf(error: unknown): string | undefined {
  return firstGraphQLError(error)?.extensions?.code;
}

/** A message for the Provider: the API's own words when it sent any. */
export function serviceErrorMessage(
  error: unknown,
  fallback = 'Something went wrong. Try again.',
): string {
  return stayErrorMessage(error, fallback);
}
